import { Component } from '@angular/core';

interface CourseItem {
  id: number;
  name: string;
  route: string;
  degree: string;
  duration: string;
}

interface PersonItem {
  id: number;
  name: string;
}

@Component({
  selector: 'app-courses-list-page',
  templateUrl: './courses-list-page.component.html',
  styleUrls: ['./courses-list-page.component.scss']
})
export class CoursesListPageComponent {
  brochureImage = '/assets/img/blog/blog1.jpg';
  phdBannerImage = '/assets/img/courses/phd-mechanical-engineering.png';
  showBrochureModal = false;

  ugCourses: CourseItem[] = [
    {
      id: 1,
      name: 'B.E. Civil Engineering',
      route: '/civil',
      degree: 'UG',
      duration: '4 Years'
    },
    {
      id: 2,
      name: 'B.E. Computer Science & Engineering',
      route: '/cse',
      degree: 'UG',
      duration: '4 Years'
    },
    {
      id: 3,
      name: 'B.E. Computer Science & Engineering (AI & ML)',
      route: '/ai',
      degree: 'UG',
      duration: '4 Years'
    },
    {
      id: 4,
      name: 'B.Tech. Artificial Intelligence & Data Science',
      route: '/ai',
      degree: 'UG',
      duration: '4 Years'
    },
    {
      id: 5,
      name: 'B.E. Computer Science & Engineering (Cyber Security)',
      route: '/cs',
      degree: 'UG',
      duration: '4 Years'
    },
    {
      id: 6,
      name: 'B.E. Electronics & Communication Engineering',
      route: '/ece',
      degree: 'UG',
      duration: '4 Years'
    },
    {
      id: 7,
      name: 'B.E. Electrical & Electronics Engineering',
      route: '/eee',
      degree: 'UG',
      duration: '4 Years'
    },
    {
      id: 8,
      name: 'B.E. Mechanical Engineering',
      route: '/mech',
      degree: 'UG',
      duration: '4 Years'
    }
  ];

  pgCourses: CourseItem[] = [
    {
      id: 1,
      name: 'MBA (Master of Business Administration)',
      route: '/',
      degree: 'PG',
      duration: '2 Years'
    },
    {
      id: 2,
      name: 'M.E. Computer Science & Engineering',
      route: '/',
      degree: 'PG',
      duration: '2 Years'
    },
    {
      id: 3,
      name: 'M.E. Embedded System & Technologies',
      route: '/',
      degree: 'PG',
      duration: '2 Years'
    },
    {
      id: 4,
      name: 'M.E. Thermal Engineering',
      route: '/',
      degree: 'PG',
      duration: '2 Years'
    },
    {
      id: 5,
      name: 'M.E. Environmental Engineering',
      route: '/',
      degree: 'PG',
      duration: '2 Years'
    }
  ];

  phdCourses: CourseItem[] = [
    {
      id: 1,
      name: 'Ph.D. Mechanical Engineering',
      route: '/mech',
      degree: 'Ph.D',
      duration: 'Full Time / Part Time'
    }
  ];

  admissionPhones: string[] = [
    '9942982322',
    '9942982311',
    '9942982321'
  ];

  coordinators: PersonItem[] = [
    { id: 1, name: 'Dr. S. Saravana Kumar - Admission Head' },
    { id: 2, name: 'Mr. Jeyakumar - Admission Coordinator' },
    { id: 3, name: 'Mrs. Jebane - Admission Coordinator' }
  ];

  openBrochureModal(): void {
    this.showBrochureModal = true;
    document.body.style.overflow = 'hidden';
  }

  closeBrochureModal(): void {
    this.showBrochureModal = false;
    document.body.style.overflow = '';
  }

  isDisabledRoute(route: string): boolean {
    return !route || route.trim() === '/' || route.trim() === '';
  }

  trackById(index: number, item: { id: number }): number {
    return item.id;
  }

  trackByValue(index: number, value: string): string {
    return value;
  }
}